import { render } from "./Play.vue?vue&type=template&id=d98d1e8e"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
script.render = render

export default script